import Vue from "vue";
export default {
  methods: {
    doubleClickEdit(obj, type) {
      Vue.$log.debug(obj);
      if (!type) {
        throw new Error("No type for object specified: " + JSON.stringify(obj));
      }
      this.$router.push({
        name: type,
        params: { id: obj.obj.id },
        query: this.$route.query
      });
    }
  }
};
